const share = {
    init() {
        const triggers = document.querySelectorAll('.js-share-trigger');
        triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();

                if (navigator.share) {
                    navigator.share({
                        url: window.location,
                        title: trigger.dataset.title,
                        text: trigger.dataset.text,
                    })
                        .catch(() => {
                            this.openSharePopup(trigger);
                        });
                } else {
                    this.openSharePopup(trigger);
                }
            });
        });
    },

    openSharePopup(trigger) {
        const popup = window.open(`${trigger.href}${window.location}`, 'popup', 'width=600,height=600');
        popup.focus();
    },
};

export default share;
